export default "__VITE_ASSET__$Or0PijT__"